// removed by extract-text-webpack-plugin
module.exports = {"monospace-font-family":"'Roboto Mono', monospace","ixt-red":"#FF5555"};


//////////////////
// WEBPACK FOOTER
// ./src/components/specimen-examples/ColorSpecimenExample.css
// module id = 571
// module chunks = 2